<template>
    <div>
        
        <v-row v-if="isLoading">
            <v-col v-for="i in ( this.isMobile ? 1 : 12/cols)"
                   :key="i">
               <v-skeleton-loader
                   type="image"
                ></v-skeleton-loader>
           </v-col>
        </v-row>

        <div v-else>

            <v-carousel
              :continuous="true"
              :cycle="true"
              :show-arrows="false"
              :hide-delimiters="categories.length <= 1"
              hide-delimiter-background
              delimiter-icon="mdi-minus"
              v-if="isMobile"
              height="250px"
            >
                <v-carousel-item v-for="(category, i) in categories"
                                 :key="i"
                                 class="px-3">
                    <CategoryCard :category="category"
                                  @click="goToCategory"/>
                </v-carousel-item>
            </v-carousel>

            <v-row v-else>
                <v-col v-for="category in categories"
                       :key="category.id"
                       :cols="cols">
                    <CategoryCard :category="category"
                                  @click="goToCategory"/>
               </v-col>
            </v-row>
            
        </div>

    </div>
</template>

<script>
import API from '@/api'

import utility from '@/mixins/utility'

import CategoryCard from '@/components/Categories/CategoryCard'

export default 
{
   name: 'Categories',

   mixins: [ utility ],

   components:
   {
     CategoryCard
   },

   data: () => ({
     categories: [],
     isLoading: false
   }),

   props:
   {
      cols:
      {
         type: Number,
         default: 4
      }
   },

   computed:
   {
     
   },

   methods:
   {
     load()
     {
        this.isLoading = true

        API.category.list()
                    .then(({ data })=>{
                        this.categories = this.mapModels(data.data, 'category')
                    })
                    .finally(()=>this.isLoading=false)
     },
     goToCategory(category)
     {
        this.goTo({ name:'category', params: { slug:category.slug, category } })
     }
   },

   mounted()
   {
    this.load()
   }
}
</script>